import { render } from "./MissingDeposit.vue?vue&type=template&id=1f0128f4&scoped=true"
import script from "./MissingDeposit.vue?vue&type=script&lang=js"
export * from "./MissingDeposit.vue?vue&type=script&lang=js"

import "./MissingDeposit.vue?vue&type=style&index=0&id=1f0128f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f0128f4"]])

export default __exports__